import { gql } from '@apollo/client';
const fetchAllDataQuery = (employeeID) => gql `
    {
        employee(employeeId: "${employeeID}") {
            employeeId,
            preferredFirstName,
            preferredLastName,
            login,
            jobInformation {
                jobProfileName,
                location {
                    buildingCode,
                    countryCode,
                    timeZoneId
                }
                lineOfBusiness{
                    name
                }
            },
            enabledFeatures{
                name
            }
            localePreferences {
                languageCode
            }
        }
    }
    `;
export default fetchAllDataQuery;
//# sourceMappingURL=allDataQuery.js.map